
import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class Business extends Mappeable {

    idExternalCompanyPK: number;
    txtCompany: string;
    address: string;
    codeBusiness: string;
    email: string;
    cif: any;
    country: any;
    mrkActive: boolean

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
    }

    public mapToBack() {
        return {
            txtCompany: this.txtCompany,
            address: this.address,
            email: this.email,
            cif: this.cif,
            country: this.country,
            codeBusiness: this.codeBusiness,
            mrkActive: this.mrkActive
        }
    }


}
